import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted';
import Tooltip from '@mui/material/Tooltip';
import {
    guardarCambiosFC_09Solicitud,
    guardarCambiosFC_09ProductosSolicitud, actualizarFC_09PaginaActiva,
    actualizarFC_09Estatus, resetDataFC_09,
    agregarFC_09AnexoProducto,
    agregarMapFC_09Accion,
    // agregarMapAnexosFC_09Accion,
    obtenerIdCliente,
    actualizarFC_09MapSolicitud,
    actualizarFC_09Solicitud,
    actualizarFC_09SolicitudMap,
    generarDocumentosFC_09,
    aceptarSolicitudFC_09,
    obtenerSolicitudDetalleFC_09,
    obtenerSolicitudDetalleFC_09ConMaps,
    actualizarFC_09Formulario

} from '../../../redux/DucksAtencionACliente/FC_09AtencionAClienteDucks';
import { AcualizarFormatoAccion, obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import TextField from '@mui/material/TextField';
import { withRouter } from 'react-router-dom'
import { host } from '../../../configuraciones'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BotonDescargarArchivos from '../../App/BotonDescargarArchivos';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster)

import estilos from './AtencionAClientesFC_09Component.module.css';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import FormularioDocumentacionFC_09 from '../../UsuarioBeneficiario/FormularioFC09/FormularioDocumentacionFC_09';
{ {/*Estilos para el componente*/ } }
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const { useState, useEffect, useRef } = React;

const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};

function FC_09Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const dataUser = useSelector(store => store.Usuario.user)
    const currentUser = useSelector(store => store.Usuario.data)
    // const formato = useSelector(store => store.AtencionSolicitud.formato)
    const modoVerDetalle = useSelector(store => store.FC_09SolicitudAtencionACliente.modoVerDetalle)
    let fc_09Map = useSelector(store => store.FC_09SolicitudAtencionACliente.fc_09Map)
    let fc_09ProductosMap = useSelector(store => store.FC_09SolicitudAtencionACliente.productosMap)
    let filesMap = useSelector(store => store.FC_09SolicitudAtencionACliente.filesMap)
    let filesProductosMap = useSelector(store => store.FC_09SolicitudAtencionACliente.filesProductosMap)

    const modoEdicionBorrador = useSelector(store => store.FC_09SolicitudAtencionACliente.modoEdicionBorrador)
    let solicitud = useSelector(store => store.FC_09SolicitudAtencionACliente.data)

    const idUsuario = usuario.data.user[0].id
    var fechaHoy = moment().format('YYYY-MM-DD')

    let fechaVisita = solicitud.fechavisitapropuesta.substring(0, 10)
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3, 4])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Servicio solicitado', 'Características de productos', 'Información del importador', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }

    let servicioSolicitado = []
    let documentacionGeneral = []
    documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN GENERAL' })
    for (const i in solicitud.fc_09archivos) {
        const { ...anexo } = solicitud.fc_09archivos[i]
        let filtro = filesMap.filter(anexos => anexos.idfc_09archivos === anexo.idfc_09archivos)
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: filtro[0]?.observacion ? filtro[0]?.observacion : '',
            correcto: filtro[0] ? !filtro[0]?.estatuscheck : false,
            incorrecto: filtro[0] ? filtro[0]?.estatuscheck : false,
            fechaInicio: anexo.fechainicio ? anexo.fechainicio : '',
            fechaTermino: anexo.fechafin ? anexo.fechafin : '',
            estatus: 'Agregar',
            idMap: filtro[0] ? filtro[0]?.idfc09_archivomap : '',
            idfc_09archivos: anexo?.idfc_09archivos,
            tabla: 'fc_09archivos', nombreId: 'idfc09_solicitudcertificado', idSolicitud: anexo.idfc09_solicitudcertificado,
            nameid: anexo.nameid, nameDoc: anexo.nameid === 'DGFP' ? 'Factura o proforma' : 'Orden de compra'
        })
    }
    // documentacionGeneral.push({
    //     id: uuidv4(),
    //     observaciones: filesMap[0]?.observacion ? filesMap[0]?.observacion : '',
    //     correcto: filesMap[0] ? !filesMap[0].estatuscheck : false,
    //     incorrecto: filesMap[0] ? filesMap[0].estatuscheck : false,
    //     fechaInicio: solicitud.fc_09archivos[0] ? solicitud.fc_09archivos[0].fechainicio : '',
    //     fechaTermino: solicitud.fc_09archivos[0] ? solicitud.fc_09archivos[0].fechafin : '',
    //     estatus: 'Agregar',
    //     idMap: filesMap[0]?.idfc09_archivomap ? filesMap[0]?.idfc09_archivomap : '',
    //     idfc_09archivos: solicitud.fc_09archivos?.[0]?.idfc_09archivos,
    //     tabla: 'fc_09archivos', nombreId: 'idfc09_solicitudcertificado', idSolicitud: solicitud.idfc09_solicitudcertificado,
    //     nameid: `DGOC`, nameDoc: 'Orden de compra'
    // },
    //     {
    //         id: uuidv4(),
    //         observaciones: filesMap[1]?.observacion ? filesMap[1]?.observacion : '',
    //         correcto: filesMap[1] ? !filesMap[1].estatuscheck : false,
    //         incorrecto: filesMap[1] ? filesMap[1].estatuscheck : false,
    //         fechaInicio: solicitud.fc_09archivos[1] ? solicitud.fc_09archivos[1].fechainicio : '',
    //         fechaTermino: solicitud.fc_09archivos[1] ? solicitud.fc_09archivos[1].fechafin : '',
    //         estatus: 'Agregar',
    //         idMap: filesMap[1]?.idfc09_archivomap ? filesMap[1]?.idfc09_archivomap : '',
    //         idfc_09archivos: solicitud.fc_09archivos?.[1]?.idfc_09archivos,
    //         tabla: 'fc_09archivos', nombreId: 'idfc09_solicitudcertificado', idSolicitud: solicitud.idfc09_solicitudcertificado,
    //         nameid: `DGFP`, nameDoc: 'Factura o proforma'
    //     }
    // )
    documentacionGeneral.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN DE PRODUCTOS' })

    if (solicitud.maquilador) {
        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Tipo Instalación', valor: 'Maquilador', idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.mauilador : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.mauiladorcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.mauiladorcheck : false,
            }, {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproducto : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.domicilioproductocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproductocheck : false,
        }, {
            id: uuidv4(), Campo: 'Numero de socio', valor: solicitud.numerosocio,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.numerosocio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.numerosociocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.numerosociocheck : false,
        }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: solicitud.resposableinstalaciones,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronicocheck : false,
        })
    }
    if (solicitud.propia) {
        let cortarResponsable = solicitud.resposableinstalaciones.split('/')
        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Tipo Instalación', valor: 'Propia', idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.propia : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.propiacheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.propiacheck : false,
            }, {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproducto : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.domicilioproductocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproductocheck : false,
        }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: cortarResponsable?.[1] || solicitud.resposableinstalaciones,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronicocheck : false,
        })
    }
    if (solicitud.noregistradasalida) {
        servicioSolicitado.push({
            id: uuidv4(), Campo: 'Salida de una empresa no registrada', valor: solicitud.noregistradasalida === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.noregistradasalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.noregistradasalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.noregistradasalidacheck : false,
        },)
    }
    if (solicitud.noregistradasalida) {
        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Razón social', valor: solicitud.razonsocialsolicitante,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.razonsocialsolicitante : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.razonsocialsolicitantecheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.razonsocialsolicitantecheck : false,
            },{
                id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproducto : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.domicilioproductocheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioproductocheck : false,
            }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: solicitud.resposableinstalaciones,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.correoelectronicocheck : false,
        })
    }
    servicioSolicitado.push({
        id: uuidv4(), Campo: 'Entrega de hologramas', valor: solicitud.entregahologramas ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.entregahologramas : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.entregahologramascheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.entregahologramascheck : false,
    }, {
        id: uuidv4(), Campo: 'Emisión de certificado NOM de exportación', valor: solicitud.emicioncertificadonomexportacion ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.emicioncertificadonomexportacion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.emicioncertificadonomexportacioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.emicioncertificadonomexportacioncheck : false,
    }, {
        id: uuidv4(), Campo: 'Emisión de certificado NOM de exportación para promoción', valor: solicitud.emicioncertificadopromocion ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.emicioncertificadopromocion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.emicioncertificadopromocioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.emicioncertificadopromocioncheck : false,
    }, {
        id: uuidv4(), Campo: 'Inspección durante el envasado para exportación', valor: solicitud.inspeccionenvasadoparaexportaci ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.inspeccionenvasadoparaexportaci : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.inspeccionenvasadoparaexportacicheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.inspeccionenvasadoparaexportacicheck : false,
    }, {
        id: uuidv4(), Campo: 'Fecha de visita propuesta', valor: fechaVisita,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.fechavisitapropuesta : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.fechavisitapropuestacheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.fechavisitapropuestacheck : false,
    })
    let [rowsServicioSolicitado, setRowsServicioSolicitado] = React.useState(servicioSolicitado)
    let productos = []

    for (const index in solicitud.fc_09_anexoproducto) {
        documentacionGeneral.push({ id: uuidv4(), nameDoc: 'PRODUCTO: ' + Number(Number(index) + Number(1)) })
        const { ...producto } = solicitud.fc_09_anexoproducto[index]
        let filtro = fc_09ProductosMap?.filter(anexo => anexo?.idfc09_anexoproducto === producto?.idfc09_anexoproducto)
        // let filtroMap = fc_09ProductosMap?.filter(anexo => anexo.idfc09_anexoproducto === filtro)
        productos.push(
            {
                id: uuidv4(), idfc09_anexoproducto: producto.idfc09_anexoproducto,
                idfc09_anexoproductomap: filtro[0]?.idfc09_anexoproductomap ? filtro[0]?.idfc09_anexoproductomap : '',
                contenidoalcoholico: producto.contenidoalcoholico, numeroanalisis: producto.numeroanalisis,
                numerocertificado: producto.numerocertificado, marca: producto.marca, numerolote: producto.numerolote,
                contenidonetobotella: producto.contenidonetobotella + ' ' + producto.unidad, numerobotellas: producto.numerobotellas, numerocajas: producto.numerocajas,
                tipoproducto: producto.tipoproducto,
                observaciones: filtro[0] ? filtro[0].producto : '',
                correcto: filtro[0] ? !filtro[0].productocheck : false,
                incorrecto: filtro[0] ? filtro[0].productocheck : false,
            }
        )
        let analisisLaboratorio = producto.numeroanalisis.split(',')
        let numeroCertificado = producto.numerocertificado.split(',')

        for (const i in analisisLaboratorio) {
            let nameid = `DPAL${index}${i}`.toString()
            const filtroAnalisis = solicitud.fc_09_anexoproducto[index].fc_09archivoproducto.filter(anexo => anexo.nameid === nameid)
            const filtroMapProductos = filesProductosMap?.filter(anexo => anexo?.idfc_09archivoproducto === filtroAnalisis?.[0]?.idfc_09archivoproducto)
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: filtroMapProductos[0]?.observacion ? filtroMapProductos[0]?.observacion : '',
                correcto: filtroMapProductos[0] ? !filtroMapProductos[0]?.estatuscheck : false,
                incorrecto: filtroMapProductos[0] ? filtroMapProductos[0]?.estatuscheck : false,
                fechaInicio: filtroAnalisis[0]?.fechainicio ? filtroAnalisis[0]?.fechainicio : '',
                fechaTermino: filtroAnalisis[0]?.fechafin ? filtroAnalisis[0]?.fechafin : '',
                estatus: filtroAnalisis[0]?.estatus ? filtroAnalisis[0]?.estatus : 'Agregar',
                idMap: filtroMapProductos[0]?.idfc09_archivoproductomap ? filtroMapProductos[0]?.idfc09_archivoproductomap : '',
                idfc_09archivoproducto: filtroAnalisis[0]?.idfc_09archivoproducto,
                tabla: 'fc_09archivoproducto', nombreId: 'idfc09_anexoproducto', idSolicitud: producto.idfc09_anexoproducto,
                nameid: `DPAL${index}${i}`, nameDoc: 'Análisis de Laboratorio: ' + analisisLaboratorio[i]
            })
        }
        for (const i in numeroCertificado) {
            let nameid = `DPCA${index}${i}`.toString()
            const filtroCertificado = solicitud.fc_09_anexoproducto[index].fc_09archivoproducto.filter(anexo => anexo.nameid === nameid)
            const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_09archivoproducto === filtroCertificado[0]?.idfc_09archivoproducto)
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: filtroMapProductos[0]?.observacion ? filtroMapProductos[0]?.observacion : '',
                correcto: filtroMapProductos[0] ? !filtroMapProductos[0]?.estatuscheck : false,
                incorrecto: filtroMapProductos[0] ? filtroMapProductos[0]?.estatuscheck : false,
                fechaInicio: filtroCertificado[0]?.fechainicio ? filtroCertificado[0]?.fechainicio : '',
                fechaTermino: filtroCertificado[0]?.fechafin ? filtroCertificado[0]?.fechafin : '',
                estatus: filtroCertificado[0]?.estatus ? filtroCertificado[0]?.estatus : 'Agregar',
                idMap: filtroMapProductos[0]?.idfc09_archivoproductomap ? filtroMapProductos[0]?.idfc09_archivoproductomap : '',
                idfc_09archivoproducto: filtroCertificado[0]?.idfc_09archivoproducto,
                tabla: 'fc_09archivoproducto', nombreId: 'idfc09_anexoproducto', idSolicitud: producto.idfc09_anexoproducto,
                nameid: `DPCA${index}${i}`, nameDoc: 'Certificado NOM de producto a granel: ' + numeroCertificado[i]
            })
        }
        let nameid = `DPEP${index}`
        const filtroEtiqueta = solicitud.fc_09_anexoproducto[index].fc_09archivoproducto.filter(anexo => anexo.nameid === nameid)
        const filtroMapEtiqueta = filesProductosMap?.filter(anexo => anexo?.idfc_09archivoproducto === filtroEtiqueta?.[0]?.idfc_09archivoproducto)
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: filtroMapEtiqueta[0]?.observacion ? filtroMapEtiqueta[0]?.observacion : '',
            correcto: filtroMapEtiqueta[0] ? !filtroMapEtiqueta[0]?.estatuscheck : false,
            incorrecto: filtroMapEtiqueta[0] ? filtroMapEtiqueta[0]?.estatuscheck : false,
            fechaInicio: filtroEtiqueta[0]?.fechainicio ? filtroEtiqueta[0]?.fechainicio : '',
            fechaTermino: filtroEtiqueta[0]?.fechafin ? filtroEtiqueta[0]?.fechafin : '',
            estatus: filtroEtiqueta[0]?.estatus ? filtroEtiqueta[0]?.estatus : 'Agregar',
            idMap: filtroMapEtiqueta[0]?.idfc09_archivoproductomap ? filtroMapEtiqueta[0]?.idfc09_archivoproductomap : '',
            idfc_09archivoproducto: filtroEtiqueta[0]?.idfc_09archivoproducto,
            tabla: 'fc_09archivoproducto', nombreId: 'idfc09_anexoproducto', idSolicitud: producto.idfc09_anexoproducto,
            nameid: `DPEP${index}`, nameDoc: 'Etiqueta aprobada'
        })
    }
    let [rowsProductos, setRowsProductos] = React.useState(productos)
    let importador = []
    importador.push(
        {
            id: uuidv4(), Campo: 'Nombre completo', valor: solicitud.nombreimportador,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.nombreimportador : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.nombreimportadorcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.nombreimportadorcheck : false,
        }, {
        id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioimportador,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioimportador : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.domicilioimportadorcheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.domicilioimportadorcheck : false,
    }, {
        id: uuidv4(), Campo: 'Pais destino', valor: solicitud.paisdestino,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.paisdestino : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.paisdestinocheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.paisdestinocheck : false,
    }, {
        id: uuidv4(), Campo: 'Aduana salida', valor: solicitud?.aduanasalida?.aduanasalida,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.aduanasalida : false,
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.aduanasalidacheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.aduanasalidacheck : false,
    }, {
        id: uuidv4(), Campo: 'Observaciones', valor: solicitud.observaciones,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.observaciones : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? !fc_09Map?.observacionescheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_09Map) && JSON.stringify([]) !== JSON.stringify(fc_09Map) ? fc_09Map?.observacionescheck : false,
    }
    )
    let [rowsImportador, setRowsImportador] = React.useState(importador)
    // let documentacion = []
    const [rowsDocumentacion, setRowsDocumentacion] = React.useState([...documentacionGeneral])



    const handdleEditPrev = (objectProducto) => {
        const filtro = rowsServicioSolicitado.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroProducto = rowsProductos.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroImportador = rowsImportador.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowsDocumentacion.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtro !== -1) {
            rowsServicioSolicitado[filtro].valor = objectProducto.valor
            rowsServicioSolicitado[filtro].correcto = objectProducto.correcto
            rowsServicioSolicitado[filtro].incorrecto = objectProducto.incorrecto
            rowsServicioSolicitado[filtro].observaciones = objectProducto.observaciones
        }
        if (filtroProducto !== -1) {
            rowsProductos[filtroProducto].valor = objectProducto.valor
            rowsProductos[filtroProducto].correcto = objectProducto.correcto
            rowsProductos[filtroProducto].incorrecto = objectProducto.incorrecto
            rowsProductos[filtroProducto].observaciones = objectProducto.observaciones
        }
        if (filtroImportador !== -1) {
            rowsImportador[filtroImportador].valor = objectProducto.valor
            rowsImportador[filtroImportador].correcto = objectProducto.correcto
            rowsImportador[filtroImportador].incorrecto = objectProducto.incorrecto
            rowsImportador[filtroImportador].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowsDocumentacion[filtroDocumentacion].correcto = objectProducto.correcto
            rowsDocumentacion[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowsDocumentacion[filtroDocumentacion].observaciones = objectProducto.observaciones
            rowsDocumentacion[filtroDocumentacion].fechaInicio = objectProducto.fechaInicio
            rowsDocumentacion[filtroDocumentacion].fechaTermino = objectProducto.fechaTermino
        }
    }
    const columnsProductos = [
        {
            field: 'marca', headerName: 'Marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.marca}`} arrow>
                        <label>{`${params.row.marca} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numeroanalisis', headerName: 'No. de analisis', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 130,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                        <label>{`${params.row.numeroanalisis} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerocertificado}`} arrow>
                        <label>{`${params.row.numerocertificado} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'contenidoalcoholico', headerName: 'Alc. Vol', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110, },
        { field: 'contenidonetobotella', headerName: 'Cont. net.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 90, },
        { field: 'numerobotellas', headerName: 'No. de botellas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 125, },
        { field: 'numerocajas', headerName: 'No. de cajas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110, },
        {
            field: 'tipoproducto', headerName: 'Tipo producto', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 115,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipoproducto}`} arrow>
                        <label>{`${params.row.tipoproducto} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110,
            renderCell: (params) =>
            (
                <Fragment>
                    <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                    <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                </Fragment>
            )
        },
    ]
    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            <div className="form-floating mb-3" color='black'>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} />
                                {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                <label htmlFor="floatingInput">Campo</label>
                            </div>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />

                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>

                        <FormularioDocumentacionFC_09
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_09>

                        <br />

                    </Box>
                </Modal>
            </div>

        )
    }

    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_09())
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        // const idSolicitud = solicitud.idfc09_solicitudcertificado
        if (JSON.stringify({}) === JSON.stringify(fc_09Map) || JSON.stringify([]) === JSON.stringify(fc_09Map) || fc_09Map === null) {
            await agregarMapYActualizarFC_09()
            const idSolicitud = solicitud.idfc09_solicitudcertificado
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_09 = 4
            const tabla = tablaFC_09
            await dispatch(actualizarFC_09Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_09()
            const idSolicitud = solicitud.idfc09_solicitudcertificado
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_09 = 4
            const tabla = tablaFC_09
            await dispatch(actualizarFC_09Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
        // dispatch(actualizarLoadingApp_false())
    }
    const actualizarMapYActualizarFC_09 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        if (solicitud.propia) {
            principal.push({
                idfc09_solicitudcertificado: rowsServicioSolicitado[0].idfc09_solicitudcertificado,
                domicilioproducto: rowsServicioSolicitado[1].valor, //resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                // entregahologramas: rowsServicioSolicitado[5].valor ==="No"? false:rowsServicioSolicitado[5].valor ==="Si",
                //  emicioncertificadonomexportacion: rowsServicioSolicitado[6].valor,
                // emicioncertificadopromocion: rowsServicioSolicitado[7].valor, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[8].valor,
                // fechavisitapropuesta: rowsServicioSolicitado[9].valor,
                nombreimportador: rowsImportador[0].valor,
                domicilioimportador: rowsImportador[1].valor, paisdestino: rowsImportador[2].valor,
                // idaduanasalida: rowsImportador[3].valor, 
                observaciones: rowsImportador[4].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        if (solicitud.maquilador) {
            principal.push({
                idfc09_solicitudcertificado: rowsServicioSolicitado[0].idfc09_solicitudcertificado,
                domicilioproducto: rowsServicioSolicitado[1].valor, numerosocio: rowsServicioSolicitado[2].valor,
                resposableinstalaciones: rowsServicioSolicitado[3].valor,
                telefono: rowsServicioSolicitado[4].valor, correoelectronico: rowsServicioSolicitado[5].valor,
                // entregahologramas: rowsServicioSolicitado[6].valor, emicioncertificadonomexportacion: rowsServicioSolicitado[7].valor,
                // emicioncertificadopromocion: rowsServicioSolicitado[8].valor, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].valor,
                // fechavisitapropuesta: rowsServicioSolicitado[10].valor, 
                nombreimportador: rowsImportador[0].valor,
                domicilioimportador: rowsImportador[1].valor, paisdestino: rowsImportador[2].valor,
                // idaduanasalida: rowsImportador[3].valor,
                observaciones: rowsImportador[4].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        let principalMap = []
        if (solicitud.propia) {
            principalMap.push({
                propia: rowsServicioSolicitado[0].observaciones, maquilador: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, resposableinstalaciones: rowsServicioSolicitado[2].observaciones,
                telefono: rowsServicioSolicitado[3].observaciones, correoelectronico: rowsServicioSolicitado[4].observaciones,
                // entregahologramas: rowsServicioSolicitado[5].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[6].observaciones,
                // emicioncertificadopromocion: rowsServicioSolicitado[7].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[8].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[9].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: rowsImportador[3].observaciones,
                observaciones: rowsImportador[4].observaciones,

                propiacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[2].incorrecto,
                //telefonocheck: rowsServicioSolicitado[3].incorrecto, correoelectronicocheck: rowsServicioSolicitado[4].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[5].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[8].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[7].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[7].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[9].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado, numerosociocheck: false, numerosocio: ''
            })
        }
        if (solicitud.maquilador) {
            principalMap.push({
                idfc09_solicitudcertificadomap: fc_09Map?.idfc09_solicitudcertificadomap,
                maquilador: rowsServicioSolicitado[0].observaciones, propiacheck: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, numerosocio: rowsServicioSolicitado[2].observaciones,
                resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[7].observaciones,
                emicioncertificadopromocion: rowsServicioSolicitado[8].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: rowsImportador[3].observaciones,
                observaciones: rowsImportador[4].observaciones,

                maquiladorcheck: rowsServicioSolicitado[0].incorrecto, propiacheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, numerosociocheck: rowsServicioSolicitado[2].incorrecto,
                resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                //telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[7].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[8].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[9].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado,
            })
        }
        if (solicitud.noregistradasalida) {
            principalMap.push({
                noregistradasalida: rowsServicioSolicitado[0].observaciones, maquilador: '',propia:'',
                razonsocialsolicitante: rowsServicioSolicitado[1].observaciones,
                domicilioproducto: rowsServicioSolicitado[2].observaciones, resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[7].observaciones,
                emicioncertificadopromocion: rowsServicioSolicitado[8].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: '',
                //rowsImportador[3].observaciones
                observaciones: rowsImportador[4].observaciones,

                noregistradasalidacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,propiacheck:false,
                razonsocialsolicitantecheck:rowsServicioSolicitado[1].incorrecto,
                domicilioproductocheck: rowsServicioSolicitado[2].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[9].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[7].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[8].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado, numerosociocheck: false, numerosocio: ''
            })
        }

        let productosMap = []
        for (const producto of rowsProductos) {
            productosMap.push({ idfc09_anexoproductomap: producto.idfc09_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc09_anexoproducto: producto.idfc09_anexoproducto })
        }
        let archivosPrincipal = []
        let archivosPrincipalMap = []
        let archivosProductosMap = []

        let fechaInicio1 = ''
        let fechaFin1 = ''
        if (rowsDocumentacion[1]?.fechaInicio?.length > 0) fechaInicio1 = new Date(rowsDocumentacion[1]?.fechaInicio)?.toISOString()
        else fechaInicio1 = null
        if (rowsDocumentacion[1]?.fechaTermino?.length > 0) fechaFin1 = new Date(rowsDocumentacion[1]?.fechaTermino)?.toISOString()
        else fechaFin1 = null
        archivosPrincipal.push({
            fechainicio: fechaInicio1, fechafin: fechaFin1, idfc_09archivos: rowsDocumentacion[1].idfc_09archivos
        })
        let fechaInicio2 = ''
        let fechaFin2 = ''
        if (rowsDocumentacion[2]?.fechaInicio?.length > 0) fechaInicio2 = new Date(rowsDocumentacion[2].fechaInicio)?.toISOString()
        else fechaInicio2 = null
        if (rowsDocumentacion[2]?.fechaTermino?.length > 0) fechaFin2 = new Date(rowsDocumentacion[2].fechaTermino)?.toISOString()
        else fechaFin2 = null
        archivosPrincipal.push({
            fechainicio: fechaInicio2, fechafin: fechaFin2, idfc_09archivos: rowsDocumentacion[2].idfc_09archivos
        })

        archivosPrincipalMap.push({
            idfc09_archivomap: rowsDocumentacion[1]?.idMap ? rowsDocumentacion[1]?.idMap : '',
            idfc_09archivos: rowsDocumentacion[1].idfc_09archivos, observacion: rowsDocumentacion[1].observaciones,
            estatuscheck: rowsDocumentacion[1].incorrecto
        })
        archivosPrincipalMap.push({
            idfc09_archivomap: rowsDocumentacion[2]?.idMap ? rowsDocumentacion[2]?.idMap : '',
            idfc_09archivos: rowsDocumentacion[2].idfc_09archivos, observacion: rowsDocumentacion[2].observaciones,
            estatuscheck: rowsDocumentacion[2].incorrecto
        })
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPEP") {
                archivosProductosMap.push({
                    idfc09_archivoproductomap: rowsDocumentacion[anexo]?.idMap ? rowsDocumentacion[anexo]?.idMap : '',
                    estatuscheck: rowsDocumentacion[anexo]?.incorrecto, observacion: rowsDocumentacion[anexo]?.observaciones,
                    idfc_09archivoproducto: rowsDocumentacion[anexo]?.idfc_09archivoproducto,
                })
            }
        }
        let archivosProductos = []
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPEP") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowsDocumentacion[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowsDocumentacion[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowsDocumentacion[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowsDocumentacion[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_09archivoproducto: rowsDocumentacion[anexo]?.idfc_09archivoproducto
                })
            }
        }
        const formato = { solicitud: principal[0], archivosPrincipal: archivosPrincipal, archivosProductos: archivosProductos }
        const formatoMap = { idfc09_solicitudcertificadomap: fc_09Map.idfc09_solicitudcertificadomap, solicitud: principalMap, productosMap: productosMap, archivosPrincipalMap: archivosPrincipalMap, archivosProductosMap: archivosProductosMap }
        await dispatch(actualizarFC_09Solicitud(formato))
        await dispatch(actualizarFC_09SolicitudMap(formatoMap))
        return true
    }
    const agregarMapYActualizarFC_09 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        if (solicitud.propia) {
            principal.push({
                idfc09_solicitudcertificado: rowsServicioSolicitado[0].idfc09_solicitudcertificado,
                domicilioproducto: rowsServicioSolicitado[1].valor, resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                // entregahologramas: rowsServicioSolicitado[5].valor ==="No"? false:rowsServicioSolicitado[5].valor ==="Si",
                //  emicioncertificadonomexportacion: rowsServicioSolicitado[6].valor,
                // emicioncertificadopromocion: rowsServicioSolicitado[7].valor, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[8].valor,
                // fechavisitapropuesta: rowsServicioSolicitado[9].valor,
                nombreimportador: rowsImportador[0].valor,
                domicilioimportador: rowsImportador[1].valor, paisdestino: rowsImportador[2].valor,
                // idaduanasalida: rowsImportador[3].valor, 
                observaciones: rowsImportador[4].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        if (solicitud.maquilador) {
            principal.push({
                idfc09_solicitudcertificado: rowsServicioSolicitado[0].idfc09_solicitudcertificado,
                domicilioproducto: rowsServicioSolicitado[1].valor, numerosocio: rowsServicioSolicitado[2].valor,
                resposableinstalaciones: rowsServicioSolicitado[3].valor,
                //telefono: rowsServicioSolicitado[4].valor, correoelectronico: rowsServicioSolicitado[5].valor,
                // entregahologramas: rowsServicioSolicitado[6].valor, emicioncertificadonomexportacion: rowsServicioSolicitado[7].valor,
                // emicioncertificadopromocion: rowsServicioSolicitado[8].valor, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].valor,
                // fechavisitapropuesta: rowsServicioSolicitado[10].valor, 
                nombreimportador: rowsImportador[0].valor,
                domicilioimportador: rowsImportador[1].valor, paisdestino: rowsImportador[2].valor,
                // idaduanasalida: rowsImportador[3].valor,
                observaciones: rowsImportador[4].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        let principalMap = []
        if (solicitud.propia) {
            principalMap.push({
                propia: rowsServicioSolicitado[0].observaciones, maquilador: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, resposableinstalaciones: rowsServicioSolicitado[2].observaciones,
                telefono: rowsServicioSolicitado[3].observaciones, correoelectronico: rowsServicioSolicitado[4].observaciones,
                entregahologramas: rowsServicioSolicitado[5].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[6].observaciones,
                emicioncertificadopromocion: rowsServicioSolicitado[7].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[8].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[9].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: '',
                //rowsImportador[3].observaciones
                observaciones: rowsImportador[4].observaciones,

                propiacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[2].incorrecto,
                telefonocheck: rowsServicioSolicitado[3].incorrecto, correoelectronicocheck: rowsServicioSolicitado[4].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[5].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[8].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[7].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[7].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[9].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado, numerosociocheck: false, numerosocio: ''
            })
        }
        if (solicitud.maquilador) {
            principalMap.push({
                idfc09_solicitudcertificadomap: fc_09Map?.idfc09_solicitudcertificadomap,
                maquilador: rowsServicioSolicitado[0].observaciones, propiacheck: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, numerosocio: rowsServicioSolicitado[2].observaciones,
                resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[7].observaciones,
                emicioncertificadopromocion: rowsServicioSolicitado[8].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: '',
                //rowsImportador[3].observaciones
                observaciones: rowsImportador[4].observaciones,

                maquiladorcheck: rowsServicioSolicitado[0].incorrecto, propiacheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, numerosociocheck: rowsServicioSolicitado[2].incorrecto,
                resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                //telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[7].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[8].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[9].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado,
            })
        }
        if (solicitud.noregistradasalida) {
            principalMap.push({
                noregistradasalida: rowsServicioSolicitado[0].observaciones, maquilador: '',propia:'',
                razonsocialsolicitante: rowsServicioSolicitado[1].observaciones,
                domicilioproducto: rowsServicioSolicitado[2].observaciones, resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones, emicioncertificadonomexportacion: rowsServicioSolicitado[7].observaciones,
                emicioncertificadopromocion: rowsServicioSolicitado[8].observaciones, inspeccionenvasadoparaexportaci: rowsServicioSolicitado[9].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                nombreimportador: rowsImportador[0].observaciones, domicilioimportador: rowsImportador[1].observaciones,
                paisdestino: rowsImportador[2].observaciones, idaduanasalida: '',
                //rowsImportador[3].observaciones
                observaciones: rowsImportador[4].observaciones,

                noregistradasalidacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,propiacheck:false,
                razonsocialsolicitantecheck:rowsServicioSolicitado[1].incorrecto,
                domicilioproductocheck: rowsServicioSolicitado[2].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto, emicioncertificadonomexportacioncheck: rowsServicioSolicitado[9].incorrecto,
                emicioncertificadopromocioncheck: rowsServicioSolicitado[7].incorrecto, inspeccionenvasadoparaexportacicheck: rowsServicioSolicitado[8].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                nombreimportadorcheck: rowsImportador[0].incorrecto, domicilioimportadorcheck: rowsImportador[1].incorrecto,
                paisdestinocheck: rowsImportador[2].incorrecto, idaduanasalidacheck: rowsImportador[3].incorrecto,
                observacionescheck: rowsImportador[4].incorrecto,
                idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado, numerosociocheck: false, numerosocio: ''
            })
        }

        let productosMap = []
        for (const producto of rowsProductos) {
            productosMap.push({ idfc09_anexoproductomap: producto.idfc09_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc09_anexoproducto: producto.idfc09_anexoproducto })
        }
        let archivosPrincipal = []
        let archivosPrincipalMap = []
        let archivosProductosMap = []

        let fechaInicio1 = ''
        let fechaFin1 = ''
        if (rowsDocumentacion[1]?.fechaInicio?.length > 0) fechaInicio1 = new Date(rowsDocumentacion[1]?.fechaInicio)?.toISOString()
        else fechaInicio1 = null
        if (rowsDocumentacion[1]?.fechaTermino?.length > 0) fechaFin1 = new Date(rowsDocumentacion[1]?.fechaTermino)?.toISOString()
        else fechaFin1 = null
        archivosPrincipal.push({
            fechainicio: fechaInicio1, fechafin: fechaFin1, idfc_09archivos: rowsDocumentacion[1].idfc_09archivos
        })
        let fechaInicio2 = ''
        let fechaFin2 = ''
        if (rowsDocumentacion[2]?.fechaInicio?.length > 0) fechaInicio2 = new Date(rowsDocumentacion[2].fechaInicio)?.toISOString()
        else fechaInicio2 = null
        if (rowsDocumentacion[2]?.fechaTermino?.length > 0) fechaFin2 = new Date(rowsDocumentacion[2].fechaTermino)?.toISOString()
        else fechaFin2 = null
        archivosPrincipal.push({
            fechainicio: fechaInicio2, fechafin: fechaFin2, idfc_09archivos: rowsDocumentacion[2].idfc_09archivos
        })

        archivosPrincipalMap.push({
            idfc09_archivomap: rowsDocumentacion[1]?.idMap ? rowsDocumentacion[1]?.idMap : '',
            idfc_09archivos: rowsDocumentacion[1].idfc_09archivos, observacion: rowsDocumentacion[1].observaciones,
            estatuscheck: rowsDocumentacion[1].incorrecto
        })
        archivosPrincipalMap.push({
            idfc09_archivomap: rowsDocumentacion[2]?.idMap ? rowsDocumentacion[2]?.idMap : '',
            idfc_09archivos: rowsDocumentacion[2].idfc_09archivos, observacion: rowsDocumentacion[2].observaciones,
            estatuscheck: rowsDocumentacion[2].incorrecto
        })
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPEP") {
                archivosProductosMap.push({
                    idfc09_archivoproductomap: rowsDocumentacion[anexo]?.idMap ? rowsDocumentacion[anexo]?.idMap : '',
                    estatuscheck: rowsDocumentacion[anexo]?.incorrecto, observacion: rowsDocumentacion[anexo]?.observaciones,
                    idfc_09archivoproducto: rowsDocumentacion[anexo]?.idfc_09archivoproducto,
                })
            }
        }
        let archivosProductos = []
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPEP") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowsDocumentacion[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowsDocumentacion[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowsDocumentacion[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowsDocumentacion[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_09archivoproducto: rowsDocumentacion[anexo]?.idfc_09archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosPrincipal: archivosPrincipal, archivosProductos: archivosProductos }
        let formatoMap = { solicitud: principalMap, productosMap: productosMap, archivosPrincipalMap: archivosPrincipalMap, archivosProductosMap: archivosProductosMap }

        await dispatch(agregarMapFC_09Accion(formatoMap))
        await dispatch(actualizarFC_09Solicitud(formato))
        return
    }
    const botonAceptarSolicitud = async (dataForm) => {

        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_09Map) || JSON.stringify([]) === JSON.stringify(fc_09Map) || fc_09Map === null) {
            await agregarMapYActualizarFC_09()
        } else {
            await actualizarMapYActualizarFC_09()
        }
        const dataSolicitudFC_09 = await dispatch(obtenerSolicitudDetalleFC_09ConMaps(solicitud.idfc09_solicitudcertificado))
        const solicitudParaAceptar = dataSolicitudFC_09.payload
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))

        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud, numcertificadonom: dataForm?.numCertificadoNOM,
            numerotraslado: dataForm?.numeroTraslado, otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numeroplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado, credencialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        let modal = {
            idfc09_solicitudcertificado: solicitud.idfc09_solicitudcertificado, informacionmodalaceptada: informacionmodalaceptada,
            fechaaceptada: fechaSolicitudAceptada
        }
        await (dispatch(actualizarFC_09Formulario(modal)))

        const dataImportadores = {
            nombreimportador: solicitudParaAceptar?.nombreimportador,
            domicilioimportador: solicitudParaAceptar?.domicilioimportador,
            paisdestino: solicitudParaAceptar?.paisdestino,
            observaciones: solicitudParaAceptar?.observaciones,
            idaduanasalida: solicitudParaAceptar?.idaduanasalida,
            idcliente: dataCliente.payload.cliente[0].idcliente,
        }
        const objetoCompleto = {
            dataImportadores,
            productos: solicitudParaAceptar?.fc_09_anexoproducto
        }
        await dispatch(aceptarSolicitudFC_09(objetoCompleto))

        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)

        const idSolicitud = solicitud.idfc09_solicitudcertificado
        const estatusNuevo = 4
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_09 = 4
        const tabla = tablaFC_09
        await dispatch(actualizarFC_09Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }

    const generarOficios = async (solicitudFC_09, dataCliente, dataForm) => {

        const data = {
            tipoSolicitud: 'FC_09',
            solicitudFC_09,
            dataCliente,
        }
        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: dataForm.otrosServicios,
            fechaInspeccion: dataForm.fechaInspeccion,
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_09(data))
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Servicio solicitado' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowsServicioSolicitado} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div>
                    : nombresParaPaginas[paginaActiva - 1] === 'Características de productos' ?
                        <div className='row justify-content-center'>
                            <div className='col-10'>
                                <div style={{ height: (130 + (rowsProductos?.length * 50)), width: '105%', color: 'black' }}>
                                    <DataGrid
                                        rows={rowsProductos}
                                        columns={columnsProductos}

                                        sx={{
                                            boxShadow: 0,
                                            color: 'black',
                                            border: 0,
                                            '& .MuiDataGrid-cell': {
                                                display: 'block',
                                                position: 'relative',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        : nombresParaPaginas[paginaActiva - 1] === 'Información del importador' ?
                            <div className='row justify-content-center'>
                                <div className='col-10'>
                                    <TablaAtencionACliente rows={rowsImportador} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                </div>
                            </div>
                            : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                <Fragment>

                                    <div className='row justify-content-center'>
                                        <div className='col-12' style={{ marginLeft: '7%' }}>
                                            <TablaDocumentacion rows={rowsDocumentacion} api={{ handdleEditPrev }}></TablaDocumentacion>
                                        </div>
                                    </div>
                                    {modoVerDetalle ?
                                        <div className="row text-center">
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                            </div>
                                        </div>
                                        :
                                        <div className="row text-center mt-4 mb-4">
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                            </div>

                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonDevolverSolicitud} >Devolver solicitud</button>
                                            </div>
                                        </div>
                                    }
                                </Fragment>
                                : ''
            }
            {modalComponentAceptar()}
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
        </Fragment>
    )
}

export default withRouter(FC_09Component)
